<div class="w-full mx-auto">
  <div class="flex flex-row">
    <div class="sidebar xl:block hidden basis-1/4 h-screen">
      <div id="particles" class="p-12">
        <div class="relative w-full h-full">
          <div class="text-white">
            <h1 class="text-6xl leading-tight my-5 font-bold"><ng-container i18n>Welcome to</ng-container><br />{{ appName }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full xl:basis-3/4 h-screen">
      <div class="w-full h-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<div class="version">{{ version }}</div>
